// importing styles
import "./about-section-styles.scss";

// importing icons
import { BiInfoCircle } from "react-icons/bi";
import { HiDownload } from "react-icons/hi";

// importing components
import SectionSubHeadingComponent from "../../components/section-sub-heading-component/section-sub-heading-component";
import SectionHeadingComponent from "../../components/section-heading-component/section-heading-component";
import ButtonComponent from "../../components/button-component/button-component";

const AboutSection = () => {
	return (
		<section id="about-section" className="about-section">
			<div className="about-section-content-wrapper">
				<SectionSubHeadingComponent
					icon={<BiInfoCircle />}
					text="About Me"
				/>
				<SectionHeadingComponent text="The Mind Behind the Magic: Moazam Ali" />

				{window.innerWidth <= 830 ? (
					<div className="container">
						<div className="about-container">
							<p className="about-content">
								Crafting immersive user experiences with a
								passion for innovation, expertise in React JS
								and Front-end technologies, and a dedication to
								staying ahead of industry trends. Let's bring
								your vision to life together.
							</p>
						</div>
						<ButtonComponent
							text="Download Resume"
							icon={<HiDownload />}
							btnLink={require("../../assets/moazam_ali_resume.pdf")}
							downloadBtn="true"
						/>
					</div>
				) : (
					<div className="container">
						<ButtonComponent
							text="Download Resume"
							icon={<HiDownload />}
							btnLink={require("../../assets/moazam_ali_resume.pdf")}
							downloadBtn="true"
						/>
						<div className="about-container">
							<p className="about-content">
								Crafting immersive user experiences with a
								passion for innovation, expertise in React JS
								and Front-end technologies, and a dedication to
								staying ahead of industry trends. Let's bring
								your vision to life together.
							</p>
						</div>
					</div>
				)}
			</div>
		</section>
	);
};

export default AboutSection;
